import React, { useCallback } from 'react';
import { Container, Card, CardBody, Button, Spinner } from 'reactstrap';

import { Link, useHistory } from 'react-router-dom';
import useGet from '../../helpers/hooks/useGet';

import StatList from './components/stats-list';

const AdvisoryStats = (props) => {
  const history = useHistory();
  const [advisoryStats, , advisoryStatsLoading] = useGet(
    '/advisory-stats?filter[order]=createdAt DESC',
    true
  );
  const handleEditAdvisoryStats = useCallback(
    (obj) => {
      history.push(`/system/advisors-stat-details/${obj.id}`);
    },
    [history]
  );
  return (
    <>
      <div className='page-content'>
        <Container fluid>
          <div className='align-items-end d-flex justify-content-between mb-3'>
            <h4>Problem Categories</h4>
            <Link to='/system/add-new-advisory-stat'>
              <Button
                color='primary'
                outline
                type='button'
                size='sm'
                className='waves-effect waves-light'
              >
                Add New Category{' '}
                <i className='mdi mdi-plus align-middle ml-2'></i>
              </Button>
            </Link>
          </div>
          <Card>
            <CardBody>
              {advisoryStatsLoading ? (
                <div className='text-center'>
                  <Spinner className='mr-2' color='primary' />
                </div>
              ) : (
                <StatList
                  stats={advisoryStats}
                  editStat={handleEditAdvisoryStats}
                ></StatList>
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  );
};

export default AdvisoryStats;
